define([
	'marketplace/models/mp_api_model'
], function (MPAPIModel) {
	var WalletEntryModel = MPAPIModel.extend({
		defaults: {
			expMonth: 1,
			expYear: (new Date()).getFullYear(),
			country: "US"
		},

		urlRoot: '/api/wallet/',

		clientAttrs: ['name', 'number', 'cvc', 'expMonth', 'expYear', 'zipCode', 'country'],
		isDirty: function() {
			// Returns true if any of the client-set attributes have changed
			// or if there's no id
			if(!this.get('id')) {
				return true;
			}

			// We can't rely on hasChanged() to be the attributes since the last save
			// since it's now all the attributes since the last *set*.
			// save() will call set on id and other attributes that it adds which means
			// that if we rely on hasChanged(), we'll over post/over-add wallet entries
			var self = this;
			return this.clientAttrs.some(function(attr) {
				return self.hasChanged(attr);
			});
		},

		initialize: function() {
			this.on('change:expMonth', function(model, value) {
				this.set({'expMonth': parseInt(value)}, {silent: true});
			});

			this.on('change:expYear', function(model, value) {
				this.set({'expYear': parseInt(value)}, {silent: true});
			});

			this.on('change:number', function (model, value) {
				// strip out spaces and dashes
				this.set({'number': value.replace(/-|\s/g,"")});
			});
		},

		isNew: function() {
			// Ensures that a post always happens
			return true;
		}
	});

	return WalletEntryModel;
});
